var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.small ? 'loader-container' : 'loader-container-plain',attrs:{"dir":_vm.$store.state.rightAlign ? 'rtl' : 'ltr'}},[_c('b-spinner',{staticClass:"text-center mb-2",attrs:{"variant":"primary"}}),_c('h6',{staticClass:"text-light"},[_vm._v(_vm._s(_vm.$t('loadingSpinnerText')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }